import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Card, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import { ResidualMassFileUpload } from "../../../api";
const schema = yup.object({});
class AddResidualMassUploadsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_submitted: false,
            file: null,
            errors: [],
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("file", this.state.file);
        ResidualMassFileUpload(data).then((response) => {
            this.props.handleClose();
        });
    };
    handleChange(event) {
        this.setState({
            file: event.target.files[0],
        });
    }

    render() {
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal Add-residual add-member-modal"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">{"Add File Upload"}</h4>
                </div>
                <div className="modal-body">
                    <Form
                        onSubmit={(e) => this.handleSubmit(e)}
                        autoComplete="off"
                    >
                        <Form.Row>
                            <Form.Group as={Col} xs={12} className="px-3">
                                <div class="mb-3">
                                    <Form.Label>File Upload</Form.Label>
                                    <input
                                        className="form-control"
                                        id="file"
                                        name="file"
                                        onChange={this.handleChange}
                                        type="file"
                                        accept=".zip"
                                    />
                                </div>
                            </Form.Group>
                        </Form.Row>
                        <div className="modal-footer">
                            <button
                                type="submit"
                                onClick={this.handleMassResidualUpload}
                                className="btn confirm-button"
                            >
                                {"Add"}
                            </button>
                            <button
                                className="btn cancel-button"
                                onClick={() => this.props.handleClose()}
                            >
                                Cancel
                            </button>
                        </div>
                    </Form>
                </div>
            </ReactModal>
        );
    }
}

export default AddResidualMassUploadsModal;
